export const isColumnHidden = (meta, index) => {
  if (typeof meta === 'string') {
    if (meta === '') {
      return false;
    }

    // eslint-disable-next-line no-bitwise
    return (+meta & (1 << index)) === 0;
  }

  return false;
};
